import { VpSelect, VpSelectOption } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { HomePageChannel } from '../state/home-context'

interface ChannelProps {
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  value?: HomePageChannel
}

const ChannelSelect = ({ onChange, value = 'INSTORE' }: ChannelProps) => {
  const { t } = useTranslation()

  return (
    <VpSelect
      className="mg-homepage-channel"
      name="channel"
      aria-label="channel choice"
      data-testid="channel-select"
      variant="primary"
      size="medium"
      value={value}
      onChange={onChange}
    >
      <VpSelectOption value="INSTORE" data-testid="channel-option-instore">
        {t('general.homepage.instore')}
      </VpSelectOption>
      <VpSelectOption value="OMNI" data-testid="channel-option-omni">
        {t('general.homepage.Omni')}
      </VpSelectOption>
    </VpSelect>
  )
}

export default ChannelSelect
